import { Brand } from '@axo/config/@types/Brand.types';

type TermsAndConditions = {
  tc_type: string;
  version: string;
  title: string;
  modal_title: string;
  body: string;
  action_label: string;
  _id: string;
  _publish_on: string;
};

export const getTermsVersion = (
  term: Partial<TermsAndConditions>,
  brand: Brand
) => {
  if (!term._publish_on)
    throw new Error('No publish date found on term ' + term);
  const date = new Date(term._publish_on);
  const year = date.getUTCFullYear();
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
  const day = date.getUTCDate().toString().padStart(2, '0');

  return `${term.tc_type}: ${term.version}.${year}${month}${day}-${brand};`;
};
